/** Pendant zu `<SfTextBox @bind-Value=Model.Feld … />` samt `<ValidationMessage>`. */

import { TextBox } from '@/components/ui';

import { asText, type FieldAccess } from './fieldAccess';
import { FormField } from './FormField';

export interface TextFieldProps<T> {
  form: FieldAccess<T>;
  name: keyof T & string;
  /** Beschriftung über dem Feld — Text unverändert aus REQ-10 §3/§4. */
  label: string;
}

export function TextField<T>(props: TextFieldProps<T>) {
  const { form, name } = props;
  const field = form.viewField(name);
  if (field === null) return null;

  return (
    <FormField message={form.message(name)}>
      <TextBox
        value={asText(form.value(name))}
        label={props.label}
        readOnly={field.ReadOnly}
        onChange={(value) => {
          form.setValue(name, value);
        }}
      />
    </FormField>
  );
}

export default TextField;
